var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCmdx(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#153457"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 6.5C8.5 6.22386 8.72386 6 9 6H17.5C17.7022 6 17.8845 6.12182 17.9619 6.30866C18.0393 6.4955 17.9966 6.71055 17.8536 6.85355L15.3536 9.35355C15.2598 9.44732 15.1326 9.5 15 9.5H10.5H10H8H7.5H7V17H14.319L16.119 15.5H9C8.72386 15.5 8.5 15.2761 8.5 15V10H9.5V14.5H17.5C17.7105 14.5 17.8985 14.6319 17.9701 14.8298C18.0418 15.0277 17.9818 15.2493 17.8201 15.3841L14.8201 17.8841C14.7302 17.959 14.617 18 14.5 18H6.5C6.22386 18 6 17.7761 6 17.5V9C6 8.72386 6.22386 8.5 6.5 8.5H7.5H8H10H10.5H14.7929L16.2929 7H9.5V8H8.5V6.5Z",
    fill: "#FA0D2B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmdx);
export default __webpack_public_path__ + "static/media/cmdx.be1ea74bf22e3ff5a3eaaf60fbe4567d.svg";
export { ForwardRef as ReactComponent };